<template>
	<section>
		<navigation :pages="navigation"></navigation>
		<slot></slot>
		<page v-if="current" :page="current" :hospital-id="hospitalId"></page>
	</section>
</template>

<script>
import Navigation from "./components/Navigation";
import Page from "./Page";

export default {
	name: "LayoutsHolder",
	components: {
		Navigation,
		Page
	},
	props: {
		pages: {
			type: Array,
			default: () => []
		},
		hospitalId: {
			type: Number,
			default: () => null
		},
		listingId: {
			type: Number,
			default: () => null
		},
		organisationId: {
			type: Number,
			default: () => null
		}
	},
	computed: {
		navigation() {
			return this.pages;
		},
		current() {
			return this.pages.find((page) => page.slug === this.slug);
		},
		slug() {
			return this.$route.params.page;
		}
	},
	mounted() {},
	methods: {}
};
</script>

<style scoped>
@media print {
	.d-print-4 {
		width: auto;
	}
	.d-print-8 {
		width: 100%;
	}

	.page-break {
		page-break-before: always;
		visibility: hidden;
	}
}
</style>
